import $ from 'jquery';

const table = () => {

  addSortListeners();
  function addSortListeners(){
    const sortOptions = Array.from($('[data-sortBy]'));

    sortOptions.forEach(option => {
      $(option).click(function() {
        const oldOption = $('[data-sortBy-active]')[0];
        const oldDirection = $(oldOption).attr('data-sortby-direction');

        $(oldOption).removeAttr('data-sortby-active');
        $(oldOption).removeAttr('data-sortby-direction');

        let newDirection = oldDirection == 'asc' ? 'desc' : 'asc';
        // Do not change direction if new column is selected
        if (this !== oldOption) {
          newDirection = oldDirection;
        }

        $(this).attr('data-sortby-direction', newDirection);
        $(this).attr('data-sortby-active', true);

        console.log('new option', this)
        console.log('new dir', newDirection);
        sort();
      })
    })

  }

  function sort() {
    const activeOption = $('[data-sortBy-active]')[0];
    const sortEntity = $(activeOption).attr('data-sortby');
    const sortDirection = $(activeOption).attr('data-sortby-direction');

    const unsortedRows = Array.from($('[data-toSort]'));


    const sortedRows = sortRows(unsortedRows, sortEntity, sortDirection);

    const tableBody = $('[data-to-insert-sorted]');
    if (tableBody.length) {
      $(tableBody).html();
      for (const row of sortedRows) {
        $(tableBody).append(row);
      }
    }

  }

  function sortRows(rows, sortEntity, sortDirection) {
    if (sortEntity !== 'date') {
      return [...rows].sort(function (a, b) {
        const cellOfRowA = $(a).find(`[data-table=${sortEntity}]`);
        const cellOfRowB = $(b).find(`[data-table=${sortEntity}]`);

        const textA = $(cellOfRowA).text();
        const textB = $(cellOfRowB).text();

        const sortAscending = (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        const sortDescending = (textA < textB) ? 1 : (textA > textB) ? -1 : 0;

        return sortDirection == 'asc' ? sortAscending : sortDescending;
      });
    } else if (sortEntity === 'date') {
      return [...rows].sort(function (a, b) {
        const cellOfRowA = $(a).find(`[data-table=${sortEntity}]`);
        const cellOfRowB = $(b).find(`[data-table=${sortEntity}]`);

        const textA = $(cellOfRowA).text();
        const textB = $(cellOfRowB).text();

        const sortAscending = new Date(textA) - new Date(textB);
        const sortDescending = new Date(textB) - new Date(textA);

        return sortDirection == 'asc' ? sortAscending : sortDescending;
      });
    }

    return console.error('Error, sort entity could not be obtained');
  }

  return {
    sort
  }
}

export default table;
